import React, { useState } from 'react';
import { X, Maximize2 } from 'lucide-react';

// 1. Import your local images here
import img1 from '../../assets/gallery/1.jpeg';
import img2 from '../../assets/gallery/2.jpeg';
import img3 from '../../assets/gallery/3.jpeg';
import img4 from '../../assets/gallery/4.jpeg';
import img5 from '../../assets/gallery/5.jpeg';
import img6 from '../../assets/gallery/6.jpeg';

const Gallery = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  // 2. Reference the imported variables in your array
  const images = [
    { id: 1, url: img1, title: ' ' },
    { id: 2, url: img2, title: ' ' },
    { id: 3, url: img3, title: ' ' },
    { id: 4, url: img4, title: ' ' },
    { id: 5, url: img5, title: ' ' },
    { id: 6, url: img6, title: ' ' },
    // ... add more as needed
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-8 text-center">My Gallery</h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {images.map((img) => (
          <div 
            key={img.id} 
            className="relative group overflow-hidden rounded-xl bg-gray-200 cursor-pointer aspect-square"
            onClick={() => setSelectedImg(img)}
          >
            <img 
              src={img.url} 
              alt={img.title}
              className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <Maximize2 className="text-white w-8 h-8" />
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal stays exactly the same */}
      {selectedImg && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImg(null)}>
          <button className="absolute top-6 right-6 text-white"><X size={40} /></button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImg.url} alt={selectedImg.title} className="w-full h-auto max-h-[85vh] object-contain rounded-lg" />
            <p className="text-white text-center mt-4 text-xl">{selectedImg.title}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;